/**
 * 配置区域组件
 * 根据选择的分配类型显示相应的配置界面
 */
import React from 'react';
import { Card, Alert, Input } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import EntityUserSelect from './EntityUserSelect';
import EntityRoleSelect from './EntityRoleSelect';
import EntityDeptTreeSelect from './EntityDeptTreeSelect';
import { useUserAssignmentStore } from './useUserAssignmentStore';
import { ASSIGNMENT_TYPES } from './constants';
import { ASSIGNMENT_TYPE_CONFIG } from './constants';

const { TextArea } = Input;

const ConfigurationArea = () => {
  // 直接从store获取状态和方法
  const selectedType = useUserAssignmentStore(state => state.selectedType)
  const selectedUsers = useUserAssignmentStore(state => state.selectedUsers)
  const selectedRoles = useUserAssignmentStore(state => state.selectedRoles)
  const selectedDepts = useUserAssignmentStore(state => state.selectedDepts)
  const expression = useUserAssignmentStore(state => state.expression)
  const setSelectedUsers = useUserAssignmentStore(state => state.setSelectedUsers)
  const setSelectedRoles = useUserAssignmentStore(state => state.setSelectedRoles)
  const setSelectedDepts = useUserAssignmentStore(state => state.setSelectedDepts)
  const setExpression = useUserAssignmentStore(state => state.setExpression)
  const config = ASSIGNMENT_TYPE_CONFIG[selectedType];
  
  if (!config) {
    return (
      <Card title="配置" style={{ height: '100%' }}>
        <Alert
          message="请选择分配类型"
          description="请从左侧选择一种用户分配类型进行配置"
          type="info"
          showIcon
          icon={<InfoCircleOutlined />}
        />
      </Card>
    );
  }

  const renderConfigContent = () => {
    // 静态用户选择
    if (selectedType === ASSIGNMENT_TYPES.STATIC_USER && config.needsUserSelect) {
      return (
        <div>
          <div className="mb-3 font-bold">选择用户</div>
          <EntityUserSelect
            value={selectedUsers}
            onChange={setSelectedUsers}
            multiple={true}
            placeholder="请选择用户"
            className="w-full"
          />
        </div>
      );
    }
    
    // 静态角色选择
    if (selectedType === ASSIGNMENT_TYPES.STATIC_ROLE && config.needsRoleSelect) {
      return (
        <div>
          <div className="mb-3 font-bold">选择角色</div>
          <EntityRoleSelect
            value={selectedRoles}
            onChange={setSelectedRoles}
            multiple={true}
            placeholder="请选择角色"
            className="w-full"
          />
        </div>
      );
    }
    
    // 静态部门选择
    if (selectedType === ASSIGNMENT_TYPES.STATIC_DEPT && config.needsDeptSelect) {
      return (
        <div>
          <div className="mb-3 font-bold">选择部门</div>
          <EntityDeptTreeSelect
            value={selectedDepts}
            onChange={setSelectedDepts}
            multiple
            placeholder="请选择部门"
            className="w-1/3"
          />
        </div>
      );
    }
    
    // 动态部门+角色选择
    if (selectedType === ASSIGNMENT_TYPES.DYNAMIC_DEPT_ROLE) {
      return (
        <div>
          <div className="mb-4">
            <div className="mb-3 font-bold">选择部门</div>
            <EntityDeptTreeSelect
              value={selectedDepts}
              onChange={setSelectedDepts}
              multiple={true}
              placeholder="请选择部门"
              className="w-full"
            />
          </div>
          
          <div>
            <div className="mb-3 font-bold">选择角色</div>
            <EntityRoleSelect
              value={selectedRoles}
              onChange={setSelectedRoles}
              multiple={true}
              placeholder="请选择角色"
              className="w-full"
            />
          </div>
        </div>
      );
    }
    
    // 表达式输入
    if (selectedType === ASSIGNMENT_TYPES.EXPRESSION) {
      return (
        <div>
          <div className="mb-3 font-bold">表达式</div>
          <TextArea
            value={expression}
            onChange={(e) => setExpression(e.target.value)}
            placeholder="请输入用户分配表达式"
            rows={4}
            className="w-full"
          />
          <div className="mt-2 text-xs text-gray-600">
            支持SpEL表达式，例如：#&#123;userService.getUsersByRole(&apos;manager&apos;)&#125;
          </div>
        </div>
      );
    }
    
    // 动态类型的说明
    return (
      <Alert
        message="动态分配"
        description={config.description}
        type="info"
        showIcon
        icon={<InfoCircleOutlined />}
      />
    );
  };

  return (
    <Card 
      title="配置" 
      className="h-full overflow-hidden"
      styles={{
        body: {
          maxHeight: 'calc(25vh - 40px)', 
          overflowY: 'auto',
          padding: '16px'
        }
      }}
    >
      {renderConfigContent()}
    </Card>
  );
};

export default ConfigurationArea;